import { Module } from "wrapper6";

var $ = jQuery;

export default class ScrollDownButtons extends Module {

	ready(app) {

        const COVERSECTIONS = document.querySelectorAll('.mtt-cover-widget');
        if (COVERSECTIONS.length > 0) {
            for (let i = 0; i < COVERSECTIONS.length; i++) {
                const WRAPPER = COVERSECTIONS[i];
                new ScrollDownButton(WRAPPER);
            }
        }
    }
}

class ScrollDownButton {
    constructor(WRAPPER){
        this.WRAPPER = WRAPPER;
        this.BUTTON = this.WRAPPER.querySelector('.scroll-down');
        this.init();
    }
    
    init(){
        if (this.BUTTON) {
            this.ID = this.getButtonID();
            this.TARGET = document.getElementById(this.ID);
            if (this.TARGET) {
                this.BUTTON.addEventListener('click', () => {
                    $('html, body').animate(
                        {
                          scrollTop: $(`#${this.ID}`).offset().top - this.getHeaderHeight(),
                        },
                        500,
                        'linear'
                    )
                })
            }
        }
    }

    getButtonID(){
        return this.BUTTON.getAttribute('data-id');
    }

    getHeaderHeight(){
        const HEADER = document.getElementById('main_header');
        if (HEADER) {
            return HEADER.getBoundingClientRect().height;
        }

        return 120;
    }
}